import { api } from "./client";

export const ArtistsAPI = {
  getAll: async () => {
    const { data } = await api.get("/api/v1/artists");
    return data;
  },

  update: async (id, payload) => {
    const { data } = await api.put(`/api/v1/artists/${id}`, payload);
    return data;
  },

  delete: async (id) => {
    await api.delete(`/api/v1/artists/${id}`);
    return true;
  },

  searchSpotify: async (name) => {
    const { data } = await api.get('/api/v1/artists/spotify/search', { params: { name } });
    return data; // { spotifyId: string }
  },

  spotifyCandidates: async (name, limit = 5) => {
    const { data } = await api.get('/api/v1/artists/spotify/candidates', { params: { name, limit } });
    return data; // [{ spotifyId, name, imageUrl, followers, popularity, genres, url, nameMatches }]
  },
};
